// extracted by mini-css-extract-plugin
export default {"banner":"CenterMobileIRepairMobileBanner_banner__DaxQa"};